import React from "react";

const TableHeader = (props) => {

  const { columns } = props;

  return (
    <thead className="thead-light">
      <tr>
        {columns.map((column) => (
          <th key={column.path || column.label.trim()}>{column.label}</th>
        ))}
      </tr>
    </thead>
  );
}

export default TableHeader;
